export default __webpack_public_path__ + "static/media/Highlord's Maxim of Entropy.e9f64f85.jpg";